/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
/* eslint react/prop-types: 0 */
import React from 'react';
import { head, tail } from 'ramda';
import RenderDetail from './RenderDetail';
function renderCategory(category) {
    return head(category).toUpperCase() + tail(category);
}
var CategoriesDetail = function CategoriesDetail(_a) {
    var categories = _a.categories;
    return categories && categories.length ? (React.createElement(RenderDetail, { title: "Categories" }, categories.map(renderCategory))) : null;
};
export default CategoriesDetail;
//# sourceMappingURL=CategoriesDetail.js.map